import { render, staticRenderFns } from "./myClass.vue?vue&type=template&id=0f4b9d3e&scoped=true"
import script from "./myClass.vue?vue&type=script&lang=js"
export * from "./myClass.vue?vue&type=script&lang=js"
import style0 from "./myClass.vue?vue&type=style&index=0&id=0f4b9d3e&prod&lang=scss&scoped=true"
import style1 from "./myClass.vue?vue&type=style&index=1&id=0f4b9d3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4b9d3e",
  null
  
)

export default component.exports